const initialState = null;

const ReservationStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case "setreservationStatus":
      state = action.payload;
      return state;
    default:
      return state;
  }
};

export default ReservationStatusReducer;
